import { Component, EventEmitter, Input, OnChanges, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import {LorenEntityFormModel} from '../../interfaces/loren-entity-form-model.interface.ts';
import {FormFieldInteraction} from './interfaces/form-field-interaction.interface';
import {LorenFormSubmission} from '../../interfaces/loren-form-submission.interface';
import {Router} from '@angular/router';
import {LorenBaseFeature} from '../../../../base-components/loren-base-feature/loren-base-feature';
import {LorenBreakpointObserverService} from '../../../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service';
import {LorenNavService} from '../../../loren-nav/components/loren-nav/services/loren-nav-service/loren-nav.service';
import {LorenPrivilegeEntityType} from '../../../../../features/loren-roles/interfaces/loren-role.interface';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'loren-entity-form-card',
    templateUrl: './loren-entity-form-card.component.html',
    styleUrls: ['./loren-entity-form-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenEntityFormCardComponent extends LorenBaseFeature implements OnChanges {
    private router = inject(Router);
    protected breakpointObserverService: LorenBreakpointObserverService;
    protected navService: LorenNavService;

    @Input() formModel: LorenEntityFormModel;
    @Input() validateNonDirtyFormOnSubmit: boolean;
    @Input() look = 'col-md-6';
    @Input() cardLook: string;
    @Input() editActionsRoles: LorenPrivilegeEntityType[] = [];
    @Input() useDefaultActionRouting = true;
    @Output() submitForm = new EventEmitter<LorenFormSubmission>();
    @Output() formFieldInteraction = new EventEmitter<FormFieldInteraction>();
    @Output() cancelClick = new EventEmitter<LorenEntityFormModel>();
    @Output() deleteClick = new EventEmitter<LorenEntityFormModel>();

    constructor()
    {
        const breakpointObserverService = inject(LorenBreakpointObserverService);
        const navService = inject(LorenNavService);

        super();
    
        this.breakpointObserverService = breakpointObserverService;
        this.navService = navService;
    }

    ngOnChanges(): void {
        if (this.formModel?.reloadForm) {
            this.formModel.reloadForm.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                this.formModel = {...this.formModel};
            });
        }
    }

    onSubmit(formSubmission: LorenFormSubmission) {
        this.submitForm.emit(formSubmission);
    }

    handleFormFieldInteraction($event) {
        this.formFieldInteraction.emit($event);
    }

    handleCancelClick() {
        this.cancelClick.emit(this.formModel);
        if (this.useDefaultActionRouting) {
            this.router.navigate([this.formModel.cancelActionPath]);
        }
    }

    handleDeleteClick() {
        this.deleteClick.emit(this.formModel);
        if (this.useDefaultActionRouting) {
            this.router.navigate([this.formModel.deleteActionPath]);
        }
    }
}
